"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_f28957f3{display:inline-block}\n" }]);
exports.root = "root_f28957f3";
//# sourceMappingURL=GroupSpacer.scss.js.map